function check_hidden_inputs(elm) {
    const $registeredInputs = $(elm).closest('form').find('input[name="registered"]');

    if (!$(elm).is(":checked")) {
        $("#" + $(elm).attr("data-box")).addClass("hide");
        $registeredInputs.val(0);
    }
    else {
        $("#" + $(elm).attr("data-box")).removeClass("hide");
        $registeredInputs.val(1);
    }
}

function toggleSticky($elem) {
    if ($('.md-is-visible').is(':hidden') && $('.lg-is-visible').is(':hidden') && $elem.hasClass('sticky-is-loaded')) {
        $elem
            .unstick()
            .removeClass('sticky-is-loaded');
    }
    else if (($('.md-is-visible').is(':visible') || $('.lg-is-visible').is(':visible')) && !$elem.hasClass('sticky-is-loaded')) {
        $elem
            .sticky({ topSpacing: 0 })
            .on('sticky-start', function() {
                $elem.addClass('sticky-is-loaded');
            });
    }
}

Event.on('Cart.product.after_add', function(response) {
    if (response.status) {
        window.location.reload();
    }
});

Event.on('Cart.product.updated', function(response) {
    window.location.reload();
});

$(function() {
    // old stuff from modules.ctp
    $('input[name="shipping_id"]').bind('change', function () {
        var isZasielkovna = $(this).parents('.js-shopping-modules-item').data('zasielkovna');

        $('input[name="shipping_method"]').val($(this).data('name'));

        $.each(['shipping_module_id', 'shipping_name', 'shipping_address', 'shipping_post_code', 'shipping_city', 'shipping_phone'], function() {
            $('input[name="' + this + '"]').attr('disabled', !isZasielkovna);
        });

        var payments = $(this).data('payments');
        $('input[name="payment_id"]').prop('disabled', false);
        $('input[name="payment_id"]').filter(function (index) {
            return _.indexOf(payments, parseInt($(this).val())) == -1;
        }).prop('disabled', true).prop('checked', false).trigger('change');

        if ($(this).val() != $('[name="branch_id"]').parents('.shopping-modules__item').find('[name="shipping_id"]').val()) {
            $('[name="branch_id"]:checked').prop('checked', false).trigger('change');
        }

        let besteronIsDisabled = true;
        $('.shopping-modules__dependencies .is-besteron').each(function() {
            const $input = $(this).siblings('.form-control');

            if (!$input.is(':disabled')) {
                besteronIsDisabled = false;
            }
        });

        if (besteronIsDisabled) {
            $('.fake-label').addClass('is-disabled').find('.js-accordion-header').trigger('click');
        }
        else {
            $('.fake-label').removeClass('is-disabled');
        }
    });

    $('.shopping-form').on('click', '.js-tigger-login-modal', function(event) {
        event.preventDefault();

        $('#login-modal').modal('show');
    });

    $('input[name="payment_id"]').on('change', function () {
        const $fakeLabel = $('.fake-label');

        $('input[name="payment_method"]').val($(this).data('name'));

        if ($('input[name="payment_id"]:checked').siblings('label').hasClass('is-besteron')) {
            if (!$fakeLabel.hasClass('is-active')) {
                $fakeLabel.addClass('is-active');
            }
        }
        else {
            $fakeLabel.removeClass('is-active');
        }
    });

    $('input[name="shipping_id"]:checked').trigger('change');

    // modules validate
    $('.js-form-cart-modules').on('submit', function(event) {
        event.preventDefault();
    }).validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            let result = true;

            if (!$('[name="payment_id"]').is(':checked')) {
                $('#error-payment').fadeIn(500);
                result = false;
            } else {
                if ($('#error-payment').is(':visible')) { $('#error-payment').fadeOut(500); }
            }

            if (!$('[name="shipping_id"]').is(':checked')) {
                $('#error-shipping').fadeIn(500);
                result = false;
            } else {
                if ($('#error-shipping').is(':visible')) { $('#error-shipping').fadeOut(500); }

                // branch pickup
                if (!$('[name="branch_id"]').is(':checked') && $('[name="branch_id"]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')) {
                    $('#error-branch').fadeIn(500);
                    result = false;
                }
                else {
                    if ($('#error-branch').is(':visible')) { $('#error-branch').fadeOut(500); }
                }

                if ($('input[name="shipping_module_id"]').length && !$('input[name="shipping_module_id"]').is(':disabled') && !$('input[name="shipping_module_id"]').val()) {
                    $('#error-zasielkovna').fadeIn(500);
                    result = false;
                } else {
                    $('#error-zasielkovna').fadeOut(500);
                }
            }

            if (!result) {
                $('.c-msg--error:visible').slideHere();
            }

            if (result) {
                $('.js-order-submit')
                    .prop('disabled', true)
                    .addClass('is-loading');

                form.submit();
            }
        }
    });

    $('.js-form-cart-modules').find('input[type="radio"]').on('change', function() {
        const $form = $(".js-form-cart-modules");

        $.post($form.data('update-action'), $form.serialize(), function(data) {
            const shipping = data.totals.shipping,
                payment = data.totals.payment;

            Cart.updates.totals(data.totals);

            $('.js-cart-recap-shipping').html(shipping ? Format.price(shipping) : '-');
            $('.js-cart-recap-payment').html(payment ? Format.price(payment) : '-');
            $('.recap-totals__value--products').html(Format.price(data.totals.total - shipping - payment));
        }, "json");
    });

    // besteron


    // reg form
    if ($('.js-form-reg').length > 0) {
        check_hidden_inputs($("#order-registered, #customer-registered"));

        $("#order-registered, #customer-registered").change(function () {
            check_hidden_inputs($(this));
        });
    }

    if ($('.js-order-rating-form').length > 0) {
        $('.js-order-rating-form').validate({
            submitHandler: function(form) {
                form.submit();
            }
        });

        $('.js-order-rating-stars').each(function() {
            $(this).starRating({
                starSize: 20,
                initialRating: 5,
                readOnly: false,
                starShape: 'rounded',
                emptyColor: '#E0EBF5',
                activeColor: '#F8C81C',
                hoverColor: '#F8C81C',
                ratedColor: '#F8C81C',
                useGradient: false,
                disableAfterRate: false,
                callback: function(currentRating, $el){
                    let key = $el.data('key');

                    $('input[name="product_ratings[' + key + '][rating]"]').val(currentRating);
                }
            });
        });
    }

    toggleSticky($('.js-sticky'));

    Event.on('Window.resized', function () {
        toggleSticky($('.js-sticky'));
    });

    $(document).on('show.bs.modal', '#up-sell', function (e) {
        e.preventDefault();
        e.stopPropgation();

        return false;
    });

    $('.js-bonus-trigger').on('click', function (event) {
        let $elem = $(this);

        event.preventDefault();

        if (!$(this).hasClass('shopping-bonus__trigger')) {
            $elem = $(this).parent();
        }

        $elem.addClass('is-asided');
        $elem.siblings('.shopping-bonus__form').addClass('is-asided');
    });

    $('.js-bonus-close').on('click', function () {
        $(this).parent().removeClass('is-asided');
        $(this).parent().siblings('.shopping-bonus__trigger').removeClass('is-asided');
    });

    $('.js-form-voucher').validate();
    $('.js-form-voucher-special').validate();
});
